import styled from 'styled-components';
import { IGlassesPackage } from '../../types';

interface IProps {
    className?: string;
    selectedPackage: IGlassesPackage;
}

const Description = styled.span`
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    bottom: 0;
`;

const BaseGlassesIllustration = ({
    className,
    selectedPackage,
}: IProps) => (
    <div className={className}>
        <img alt={selectedPackage.name} src={selectedPackage.imageUrl} />
        <Description>{selectedPackage.imageDescLeft}</Description>
        <Description>{selectedPackage.imageDescRight}</Description>
    </div>
);

export const GlassesIllustration = styled(BaseGlassesIllustration)`
    max-width: 300px;
    margin: 0 auto;
    position: relative;

    img {
        max-width: 100%;
    }

    ${Description}:first-of-type {
        left: 30%;
        transform: translateX(-50%);
    }

    ${Description}:last-of-type {
        right: 28%;
        transform: translateX(50%);
    }
`;
